var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37477 2.10824L3.35811 5.38324C1.74977 6.43324 1.74977 8.78324 3.35811 9.83324L8.37477 13.1082C9.27477 13.6999 10.7581 13.6999 11.6581 13.1082L16.6498 9.83324C18.2498 8.78324 18.2498 6.44157 16.6498 5.39157L11.6581 2.11657C10.7581 1.51657 9.27477 1.51657 8.37477 2.10824Z",
    fill: "#F5C814",
    fillOpacity: 0.18,
    stroke: "#F5C814",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69193 10.9001L4.68359 14.8085C4.68359 15.8668 5.50026 17.0001 6.50026 17.3335L9.15859 18.2168C9.61693 18.3668 10.3753 18.3668 10.8419 18.2168L13.5003 17.3335C14.5003 17.0001 15.3169 15.8668 15.3169 14.8085V10.9418",
    fill: "white",
    fillOpacity: 0.18
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69193 10.9001L4.68359 14.8085C4.68359 15.8668 5.50026 17.0001 6.50026 17.3335L9.15859 18.2168C9.61693 18.3668 10.3753 18.3668 10.8419 18.2168L13.5003 17.3335C14.5003 17.0001 15.3169 15.8668 15.3169 14.8085V10.9418",
    stroke: "#F5C814",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8335 12.5V7.5",
    stroke: "#F5C814",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/rewardIcon.d34039adfc63d4430958204f9ddf2631.svg";
export { ForwardRef as ReactComponent };